import { Registro } from '../types';

/**
 * Enviar una incidencia individual por email
 * @param incident - La incidencia a enviar
 * @param recipientEmail - Email(s) del destinatario. Puede ser:
 *   - Un string con un solo email: "email@example.com"
 *   - Un string con múltiples emails separados por comas: "email1@example.com, email2@example.com"
 *   - Un array de emails: ["email1@example.com", "email2@example.com"]
 */
export const sendIncidentEmail = async (
  incident: Registro,
  recipientEmail: string | string[]
): Promise<void> => {
  // Determinar la URL base correcta
  const isDevelopment = import.meta.env.DEV;
  const baseUrl = isDevelopment 
    ? '/backend/api/send-incident-email.php'  // En desarrollo usa proxy
    : 'https://control.seprovinsa.com/backend/api/send-incident-email.php';  // En producción usa URL completa
  
  const response = await fetch(baseUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      incident,
      email: recipientEmail,
    }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Error al enviar el email' }));
    throw new Error(error.message || 'Error al enviar el email');
  }

  return response.json();
};
